import React, {useEffect, useState} from 'react'
import {Blacked} from "../../../../CRM/components/styles";
import {ReactComponent as ModalCloseIcon} from "../../../../assets/HomeTownIcon/ModalCloseIcon.svg";
import styled from "styled-components";
import {MEDIA_URL} from "../../../../app/constants/APIKEYS";
import {useAgentSaleInfo} from "../../../hooks/Agent/SaleProperty/GetAgentSaleInfo";
import {useAdminContentInfo} from "../../../hooks/Admin/ContentsManage/GetAdminSaleInfo";


export const SalePreviewMonitor = ({setIsPreviewModal, itemId, agentSaleItem}) => {
  // const [selectedItem, setSelectedItem] = React.useState<any>({});

  const {adminContentInfo} = useAdminContentInfo(itemId);

  // useEffect(() => {
  //   console.log('agentSaleList', agentSaleList);
  //   setSelectedItem(agentSaleList.find((item) => itemId === item.adId));
  // }, [agentSaleList]);


  useEffect(() => {
    console.log('adminContentInfo', adminContentInfo);
  }, [adminContentInfo]);

  return (
    <>
      <Blacked onClick={() => setIsPreviewModal(false)}/>
      <ModalWrapper className={"scroll-container"}>
        <ModalHeader>
          <ModalTitle>미리보기</ModalTitle>
          <CloseIconSVG as={ModalCloseIcon} onClick={() => {
            setIsPreviewModal(false)
          }}/>
        </ModalHeader>

        <Contents>
          <MonitorTitle>전면</MonitorTitle>
          {itemId ?
            <MonitorWrapper style={{display: 'flex'}}>
              <FullImg src={adminContentInfo?.fileList && MEDIA_URL + adminContentInfo?.fileList[0]?.url}/>
              <SaleWrapper>
                <SaleTitle>{`${adminContentInfo?.title || ''} ${adminContentInfo?.type || ''}`}</SaleTitle>
                <SaleAddress>{`${adminContentInfo?.address || ''}`}</SaleAddress>
                <SalePrice>{`${adminContentInfo?.price || ''}`}</SalePrice>
                <SaleSize>{`${adminContentInfo?.size || ''}`}</SaleSize>
                <SaleDescription>{`${adminContentInfo?.desc || ''}`}</SaleDescription>
              </SaleWrapper>
            </MonitorWrapper>
          :
            <MonitorWrapper style={{display: 'flex'}}>
              <FullImg src={agentSaleItem?.fileList && MEDIA_URL + agentSaleItem?.fileList[0]?.url}/>
              <SaleWrapper>
                <SaleTitle>{`${agentSaleItem?.type || ''} ${agentSaleItem?.transactionType || ''}`}</SaleTitle>
                <SaleAddress>{`${agentSaleItem?.address || ''}`}</SaleAddress>
                <SalePrice>{`${agentSaleItem?.price || ''}`}</SalePrice>
                <SaleSize>{`${agentSaleItem?.size || ''}`}</SaleSize>
                <SaleDescription>{`${agentSaleItem?.desc || ''}`}</SaleDescription>
              </SaleWrapper>
            </MonitorWrapper>
          }
        </Contents>

        <Contents>
          <MonitorTitle>2면</MonitorTitle>
          <MonitorWrapper style={{padding: 4}}>
            <div style={{display: "flex", justifyContent: "center", gap: 6}}>
              {itemId ?
                <div style={{display: "flex", border: '1px solid black', width: '198px'}}>
                  <TwoBigImg src={adminContentInfo?.fileList && MEDIA_URL + adminContentInfo?.fileList[0]?.url}/>
                  <TwoSaleWrapper>
                    <TwoSaleTitle>{`${adminContentInfo?.title || ''} ${adminContentInfo?.type || ''}`}</TwoSaleTitle>
                    <TwoSaleAddress>{`${adminContentInfo?.address || ''}`}</TwoSaleAddress>
                    <TwoSalePrice>{`${adminContentInfo?.price || ''}`}</TwoSalePrice>
                    <TwoSaleSize>{`${adminContentInfo?.size || ''}`}</TwoSaleSize>
                    <TwoSaleDescription>{`${adminContentInfo?.desc || ''}`}</TwoSaleDescription>
                  </TwoSaleWrapper>
                </div>
                :
                <div style={{display: "flex", border: '1px solid black', width: '198px'}}>
                  <TwoBigImg src={agentSaleItem?.fileList && MEDIA_URL + agentSaleItem?.fileList[0]?.url}/>
                  <TwoSaleWrapper>
                    <TwoSaleTitle>{`${agentSaleItem?.type || ''} ${agentSaleItem?.transactionType || ''}`}</TwoSaleTitle>
                    <TwoSaleAddress>{`${agentSaleItem?.address || ''}`}</TwoSaleAddress>
                    <TwoSalePrice>{`${agentSaleItem?.price || ''}`}</TwoSalePrice>
                    <TwoSaleSize>{`${agentSaleItem?.size || ''}`}</TwoSaleSize>
                    <TwoSaleDescription>{`${agentSaleItem?.desc || ''}`}</TwoSaleDescription>
                  </TwoSaleWrapper>
                </div>
              }
              <TwoBig/>
            </div>

            <div style={{display: "flex", justifyContent: "center", gap: 5, marginTop: 5}}>
              <TwoSmall/>
              <TwoSmall/>
              <TwoSmall/>
              <TwoSmall/>
            </div>
          </MonitorWrapper>
        </Contents>

        <Contents>
          <MonitorTitle>6면</MonitorTitle>
          <MonitorWrapper style={{padding: 4}}>
            <div style={{display: "flex", justifyContent: "center", gap: 3}}>
              {itemId ?
                <SixSaleWrapper>
                  <SixSaleTitle>{`${adminContentInfo?.title || ''} ${adminContentInfo?.type || ''}`}</SixSaleTitle>
                  <SixSaleAddress>{`${adminContentInfo?.address || ''}`}</SixSaleAddress>
                  <SixSalePrice>{`${adminContentInfo?.price || ''}`}</SixSalePrice>
                  <SixSaleSize>{`${adminContentInfo?.size || ''}`}</SixSaleSize>
                  <SixSaleDescription>{`${adminContentInfo?.desc || ''}`}</SixSaleDescription>
                </SixSaleWrapper>
              :
                <SixSaleWrapper>
                  <SixSaleTitle>{`${agentSaleItem?.type || ''} ${agentSaleItem?.transactionType || ''}`}</SixSaleTitle>
                  <SixSaleAddress>{`${agentSaleItem?.address || ''}`}</SixSaleAddress>
                  <SixSalePrice>{`${agentSaleItem?.price || ''}`}</SixSalePrice>
                  <SixSaleSize>{`${agentSaleItem?.size || ''}`}</SixSaleSize>
                  <SixSaleDescription>{`${agentSaleItem?.desc || ''}`}</SixSaleDescription>
                </SixSaleWrapper>
              }
              <SixBox />
              <SixBox />
            </div>

            <div style={{display: "flex", justifyContent: "center", gap: 3, marginTop: 3}}>
              <SixBox />
              <SixBox />
              <SixBox />
            </div>
          </MonitorWrapper>
        </Contents>

      </ModalWrapper>
    </>
  )
}

const ModalWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 820px;
    width: 580px;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    z-index: 99999;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`

const CloseIconSVG = styled.svg`
    width: 24px;
    cursor: pointer;
`

const ModalTitle = styled.div`
    font-family: Pretendard, sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 21.48px;
    color: #2E2559;
`

const Contents = styled.div`
    margin-top: 45px;
    font-weight: 400;
    font-size: 15px;
    line-height: 17.9px;
    font-family: Pretendard, sans-serif;
    color: #000000;
    white-space: pre-wrap;
    text-align: center;
`

const MonitorTitle = styled.div`
    font-weight: 600;
    font-size: 15px;
    line-height: 17.9px;
    font-family: pretendard, sans-serif;
    margin-bottom: 10px;
`

const MonitorWrapper = styled.div`
    border: 12.87px solid #000000;
    width: 437.61px;
    height: 257.42px;
    
`

const FullImg = styled.img`
    background-color: #D9D9D9;
    width: 50%;
    height: 100%;
`

const SaleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
`

const SaleTitle = styled.div`
    font-size: 20px;
    margin-bottom: 15px;
`

const SalePrice = styled.div`
    font-size: 19px;
    margin-bottom: 15px;
`

const SaleAddress = styled.div`
    font-size: 10px;
    margin-bottom: 4px;
`

const SaleSize = styled.div`
    font-size: 12px;
    margin-bottom: 10px;
`

const SaleDescription = styled.div`
    font-size: 10px;
    margin-bottom: 4px;
    white-space: pre-wrap;
`



const TwoBigImg = styled.img`
    background-color: #D9D9D9;
    width: 50%;
    height: 142.01px;
`


const TwoSaleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
`

const TwoSaleTitle = styled.div`
    font-size: 10px;
    margin-bottom: 5;
`

const TwoSalePrice = styled.div`
    font-size: 10px;
    margin-bottom: 5px;
`

const TwoSaleAddress = styled.div`
    font-size: 6px;
`

const TwoSaleSize = styled.div`
    font-size: 7px;
    margin-bottom: 5px;
`

const TwoSaleDescription = styled.div`
    font-size: 5px;
    line-height: 7px;
    white-space: pre-wrap;
`






const TwoBig = styled.div`
    background-color: #D9D9D9;
    width: 198px;
    height: 142.01px;
`

const TwoSmall = styled.img`
    background-color: #D9D9D9;
    width: 96.96px;
    height: 77.01px;
`

const SixImg = styled.img`
    background-color: #D9D9D9;
    width: 133px;
    height: 111.55px;
`

const SixBox = styled.div`
    background-color: #D9D9D9;
    width: 133px;
    height: 111.55px;
`


const SixSaleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 133px;
    border: black 1px solid;
`

const SixSaleTitle = styled.div`
    font-size: 12px;
`

const SixSalePrice = styled.div`
    font-size: 10px;
`

const SixSaleAddress = styled.div`
    font-size: 6px;
`

const SixSaleSize = styled.div`
    font-size: 7px;
`

const SixSaleDescription = styled.div`
    font-size: 4px;
    line-height: 6px;
    white-space: pre-wrap;
`
